export default "__VITE_ASSET__DKsiycqV__"